import * as React from 'react';
import { useSession } from 'next-auth/react';

import Loading from '~/app/components/Loading';

type ChildrenType = {
  children: React.ReactNode;
};

export function LoadingWrapper({ children }: ChildrenType) {
  const { data: session } = useSession();

  const loginProcessFinished =
    !session?.user?.employeeId || !session?.user?.globalId;

  if (loginProcessFinished) {
    return <Loading />;
  }
  return <div>{children}</div>;
}
